import { render, staticRenderFns } from "./KYCAddressDocumentProofDialog.vue?vue&type=template&id=c6573d90&scoped=true&"
import script from "./KYCAddressDocumentProofDialog.vue?vue&type=script&lang=js&"
export * from "./KYCAddressDocumentProofDialog.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=c6573d90&scoped=true&lang=css&"
import style1 from "./KYCAddressDocumentProofDialog.vue?vue&type=style&index=1&id=c6573d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6573d90",
  null
  
)

export default component.exports